var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import dealPackageService from "@irati/deals/services/package";
import FormattedMessage, { injectIntl } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import Loading from "@irati/ui/src/Loading";
import { hangPromise } from "@irati/utils/promise";
import { CircleContainer, BigLink } from "../styled";
var DIAMOND_PROMO_LINK_KEY = "setup_tenant.steps.promo.diamondHref";
var PREMIUM_PROMO_LINK_KEY = "setup_tenant.steps.promo.premiumHref";
var PLATINUM_PROMO_LINK_KEY = "setup_tenant.steps.promo.platinumHref";
var DEFAULT_PROMO_LINK_KEY = "setup_tenant.steps.promo.defaultHref";
var PromoMaterials = /** @class */ (function (_super) {
    __extends(PromoMaterials, _super);
    function PromoMaterials() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            promoLink: _this.props.formatMessage({ id: DEFAULT_PROMO_LINK_KEY }),
            load: hangPromise()
        };
        _this.getPromoLink = function (packageName) {
            var formatMessage = _this.props.formatMessage;
            switch (packageName) {
                case "Diamond":
                    return formatMessage({ id: DIAMOND_PROMO_LINK_KEY });
                case "Premium":
                    return formatMessage({ id: PREMIUM_PROMO_LINK_KEY });
                case "Platinum":
                    return formatMessage({ id: PLATINUM_PROMO_LINK_KEY });
                default:
                    return formatMessage({ id: DEFAULT_PROMO_LINK_KEY });
            }
        };
        return _this;
    }
    PromoMaterials.prototype.componentDidMount = function () {
        var _this = this;
        var load = dealPackageService.getCurrentPackage().then(function (res) {
            _this.setState({ promoLink: _this.getPromoLink(res.name) });
        });
        this.setState({ load: load });
        this.props.setIsStepCompletable(true);
    };
    PromoMaterials.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var _a = this.state, load = _a.load, promoLink = _a.promoLink;
        var step1 = formatMessage({ id: "setup_tenant.steps.promo.step1" });
        var step2 = formatMessage({ id: "setup_tenant.steps.promo.step2" });
        var step3 = formatMessage({ id: "setup_tenant.steps.promo.step3" });
        return (React.createElement(Loading, { load: load },
            React.createElement(Flex, { direction: "column", wrap: "nowrap", alignContent: "stretch" },
                React.createElement(CircleContainer, { data: [step1, step2, step3] }),
                React.createElement(BigLink, { href: promoLink, target: "_blank", uppercase: false },
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.promo.assetLink" })))));
    };
    return PromoMaterials;
}(PureComponent));
export default injectIntl(PromoMaterials);
